import {
  Organisation,
  OrganisationActivity,
  OrganisationActivityValues,
  OrganisationType,
  OrganisationTypeValues,
} from '@/domain/organisation/entities/organisation.entity';
import { validateValueInType } from '@/domain/utils/validate-value-in-type';

import { OrganisationDto } from './organisation.dto.schema';

type OrganisationDtoOmitIdAndMore = Omit<
  OrganisationDto,
  'id' | 'userId' | 'deleted'
>;

export class OrganisationMapper {
  static dtoToEntity(dto: OrganisationDto): Organisation {
    return {
      id: dto.id,
      logo: dto.logo || '',
      name: dto.name,
      type: validateValueInType<OrganisationType>(
        dto.type,
        OrganisationTypeValues,
      ),
      activity: validateValueInType<OrganisationActivity>(
        dto.activity || '',
        OrganisationActivityValues,
      ),
      location: dto.location || '',
      address: dto.address || '',
      zipCode: dto.zipCode || '',
      country: dto.country || '',
      website: dto.website || '',
    };
  }

  static entityToDto(organisation: Organisation): OrganisationDtoOmitIdAndMore {
    return {
      name: organisation.name,
      logo: organisation.logo,
      type: organisation.type,
      activity: organisation.activity,
      location: organisation.location,
      address: organisation.address,
      zipCode: organisation.zipCode,
      country: organisation.country,
      website: organisation.website,
    };
  }
}
